import "../../CustomStyles/customStyle.css";
import Minagaramlogo from "../../assets/Agarathi_logo.png";
import PlayStorelogo from "../../assets/SharethisApp/PlayStore.svg";
import AppStorelogo from "../../assets/SharethisApp/AppStore.svg";
import STA_MobileScreen from "../../assets/new_landing_page.png";
import ArrowUpRight from "../../assets/landing page/ArrowUpRight.png";
import { Button, Menu, message } from "antd";
import BackgroundImage from "../../assets/Background_image1.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import landing_image_mobile from "../../assets/mobile_back_ground_02.png";
import styles from "./landing_module.module.css";
import phone from "../../assets/mobile_back_ground_02.png";
import Footers_index from "../../Components/Footer/index_footer";
import { useNavigate } from "react-router-dom";

import {
  STR_Copy_Failure_STA,
  STR_Copy_STA,
  STR_Copy_Success_STA,
  STR_Tam_Copy_Failure_STA,
  STR_Tam_Copy_STA,
  STR_Tam_Copy_Success_STA,
} from "../../Config.js/Strings";
import { ArrowRightOutlined, LinkOutlined } from "@ant-design/icons";
import { WhatsappShareButton, WhatsappIcon } from "react-share";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
// import { Button } from "antd";
import LoginModal from "../../Pages/Authentication/Login";
import ForgetPasswordModal from "../../Pages/Authentication/ForgetPasswordView";
import SignUpModal from "../../Pages/Authentication/SignUp";
import user_icon from "../../assets/landing page/user_icon.png";
// import icon10 from "../../assets/Frame 9051.png";
import icon11 from "../../assets/inverted-commas1.png";
import { Link } from "react-router-dom";
import Word_of_the_image from "../../assets/landing page/word_of_the_day.png";
import image from "../../assets/landing page/image.png";
import audio from "../../assets/landing page/audio.png";
import select_level from "../../assets/landing page/select_level.png";
import recently_view from "../../assets/landing page/recentcly_view.png";
import saved from "../../assets/landing page/saved.png";
import idioms from "../../assets/landing page/idioms.png";
import topQuoteImage from "../../assets/right_x5F_quote.png";
import bottomQuoteImage from "../../assets/botton_left.png";
import { style } from "deprecated-react-native-prop-types/DeprecatedViewPropTypes";
import Footer from "../../Components/Footer/Footer";
const SharethisApp = ({ isTamil }) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Login modal
  const [isForgotOpen, setIsForgotOpen] = useState(false); // Forgot password modal
  const [openSignUp, setOpenSignUp] = useState(false); // Signup modal
  // ---------- OPEN / CLOSE HANDLERS ----------
  const handleOpenLogin = () => setIsModalOpen(true);
  const handleCloseLogin = () => setIsModalOpen(false);

  const handleOpenForgot = () => setIsForgotOpen(true);
  const handleCloseForgot = () => setIsForgotOpen(false);

  const handleOpenSignUp = () => setOpenSignUp(true);
  const handleCloseSignUp = () => setOpenSignUp(false);
  const testimonials = [
    {
      text: "Clean design and fast search make this app my favorite dictionary. I also enjoy the daily word feature.",
      user: "Zineerah",
    },
    {
      text: "I use Min Agaram every day. It’s meaningful, easy to use, and a true gift for Tamil learners.",
      user: "Olivia",
    },
    {
      text: "Thanks to Min Agaram, I now enjoy learning Tamil every day.",
      user: "Liam",
    },
    {
      text: "Such a helpful app for students! I use it for all my assignments and exam prep.",
      user: "Sophia",
    },
    {
      text: "This app is awesome! Every time I use it, I find new words. It’s fun to explore and learn with it!",
      user: "Reethika",
    },
    {
      text: "Love the daily word push notifications! Helps me expand my vocabulary every day.",
      user: "Siva ",
    },
  ];
  const cardData = [
    {
      title: "Word of the day",
      description:
        "Learn a word each day with its meaning, usage, and synonyms to improve your vocabulary and enhance your language skills.",
      image: Word_of_the_image,
    },
    {
      title: "Image",
      description:
        "Words with images help connect meaning visually without cost, making vocabulary easier to learn and remember.",
      image: image,
    },
    {
      title: "Audio",
      description:
        "Click the audio symbol beside a word to hear its correct pronunciation. Great for learners to improve their speaking skills.",
      image: audio,
    },
    {
      title: "Select levels",
      description:
        "Select from Elementary, Intermediate, or Advanced levels. Progressively deepen your understanding of word usage and meaning.",
      image: select_level,
    },
    {
      title: "Recently Viewed",
      description:
        "The ‘Recently Viewed’ page shows the words you explored earlier. It helps you review and reinforce your learning.",
      image: recently_view,
    },
    {
      title: "Saved",
      description:
        "The ‘Saved Words’ page stores the words you bookmarked. Revisit them anytime to strengthen your vocabulary.",
      image: saved,
    },
    {
      title: "Idioms",
      description:
        "Idioms are expressions with meanings that differ from the literal words. Learn them with examples and contextual usage.",
      image: idioms,
    },
    {
      title: "Metaphor",
      description:
        "Explore how metaphors convey one concept through another, adding depth to your understanding of language.",
      image: idioms,
    },
    {
      title: "Phrasemes",
      description:
        "Understand common word pairs and set phrases used in language. Mastering phrasemes improves fluency and accuracy.",
      image: idioms,
    },
  ];

  const settings = {
    centerMode: true,
    centerPadding: "0px", // removes extra spacing on the sides
    slidesToShow: 3,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  let agarathi_token = localStorage.getItem("agarathi_token");

  const shareUrl = "http://13.126.65.58/Min-Landing";

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareUrl);
        message.success(
          isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
        );
      } else {
        // Fallback for non-secure contexts or browsers without clipboard API
        const textArea = document.createElement("textarea");
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand("copy");
          message.success(
            isTamil ? STR_Tam_Copy_Success_STA : STR_Copy_Success_STA
          );
        } catch (err) {
          message.error(
            isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA
          );
        } finally {
          document.body.removeChild(textArea);
        }
      }
    } catch (error) {
      message.error(isTamil ? STR_Tam_Copy_Failure_STA : STR_Copy_Failure_STA);
    }
  };

  useEffect(() => {
    const openForgot = () => setIsForgotOpen(true);
    const openSignUp = () => setOpenSignUp(true);
    const openLogin = () => setIsModalOpen(true);

    window.addEventListener("openForgotPopup", openForgot);
    window.addEventListener("openSignupPopup", openSignUp);
    window.addEventListener("openLoginPopup", openLogin);

    return () => {
      window.removeEventListener("openForgotPopup", openForgot);
      window.removeEventListener("openSignupPopup", openSignUp);
      window.removeEventListener("openLoginPopup", openLogin);
    };
  }, []);

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </Menu.Item>
      {/* <Menu.Item key="2">
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </Menu.Item>
      <Menu.Item key="3">
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </Menu.Item> */}
      <Menu.Item key="2" onClick={handleCopy}>
        <Button icon={<LinkOutlined />} type="link">
          {isTamil ? STR_Tam_Copy_STA : STR_Copy_STA}
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      className={`${"pp"}`}
      style={{
        background: `linear-gradient(90deg, rgba(230, 250, 250, 0.96) 0%, rgba(230, 250, 250, 0.92) 57%, rgba(230, 250, 250, 1) 55%, rgba(230, 250, 250, 0.76) 100%, rgba(230, 250, 250, 0.45) 100%)`,
      }}
    >
      <div className="intex_page">
        {/* Logo and Title */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={Minagaramlogo}
            alt="Min Agaram Logo"
            style={{ width: "53px", marginRight: "10px" }}
          />
          <h1
            style={{ margin: 0, fontWeight: "600" }}
            className={styles.title_minagaram}
          >
            Min Agaram
          </h1>
        </div>

        {/* Login Button */}
        <div>
          <Button
            onClick={handleOpenLogin}
            type="primary"
            classNames="login_popup"
            icon={
              <img
                src={user_icon}
                alt="User"
                className="index_minagaram_button"
              />
            }
            shape="round"
            className="new_navication_bar"
          >
            Login
            <img src={ArrowUpRight} alt="Arrow" className="index_menu_button" />
          </Button>
          <LoginModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
          <ForgetPasswordModal
            open={isForgotOpen}
            onClose={() => setIsForgotOpen(false)}
          />
          <SignUpModal open={openSignUp} onClose={() => setOpenSignUp(false)} />
        </div>
      </div>

      <div className={styles.new_container}>
        <div className="container_STA">
          <p className={styles.nuance}>
            Let each Tamil word be a key unlocking culture, nuance, and fluency.
          </p>
          <p className={styles.linguistic}>
            Begin your linguistic journey with the Min Agaram app! Expertly
            developed in Singapore, this app features 50,000+ words and provides
            a comprehensive, structured, and layered learning approach to
            mastering Tamil through practical methods.
          </p>
          <p className={styles.uniqueness}>
            Experience the uniqueness of Tamil, one of the world's oldest
            languages. and richest languages.
          </p>

          <p className={styles.get_minAgaram}>
            Get Min Agaram & boost your Tamil skills!
          </p>
          <div className={styles.PlayStorelogo}>
            <div className="shareButton_STA">
              <a
                href="https://apps.apple.com/sg/app/min-agaram/id6483002626"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={AppStorelogo}
                  alt="App Store"
                  className="AppStorelogo"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.tamil_agarathi_updated"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={PlayStorelogo}
                  alt="Google Play"
                  className="PlayStorelogo"
                />
              </a>
            </div>
          </div>
        </div>
        <img
          src={STA_MobileScreen}
          alt="MobileScreen"
          className="landing_image_mobile"
        />
      </div>
      <section
        className={styles.hero}
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <h2 className={styles.headline}>Explore the Tamilverse</h2>

        <img src={phone} alt="Min Agaram phone demo" className={styles.phone} />

        <Callout
          text="Notification"
          desc="Notifications in Min Agaram keep users
updated on new words, tips, and app
enhancements."
          side={styles.top}
        />
        <Callout
          text="Search Bar"
          desc="The Search Bar in Min Agaram
enables quick and accurate word
search with smart suggestions."
          side={styles.right}
        />
        <Callout
          text="Saved Words"
          desc="The Saved Words feature in Min
Agaram lets users bookmark and
revisit important words easily."
          side={styles.bottomRight}
        />
        <Callout
          text="Word of the Day"
          desc="The Word of the Day in Min Agaram
helps users learn a new Tamil word
daily and expand their vocabulary."
          side={styles.bottomLeft}
        />
        <Callout
          text="Navigation Bar"
          desc="Allows users to access essential
features quickly for an efficient and
user-friendly experience."
          side={styles.left}
        />
      </section>
      <div>
        <div className="share_page_01">
          {/* <div className="share_grid_02">
            <Card icon={Word_of_the_image} title="Word of the day" />
            <Card icon={icon2} title="Image" />
            <Card icon={icon3} title="Audio" />
            <Card icon={icon4} title="Select levels" />
            <Card icon={icon5} title="Recently Viewed" />
            <Card icon={icon6} title="Saved Words" />
            <Card icon={icon7} title="Idioms" />
            <Card icon={icon8} title="Metaphors" />
            <Card icon={icon9} title="Phrasemes" />
          </div> */}

          <div className="landing-container">
            <h2 className="landing-container-title">
              Why You’ll Love Minagaram
            </h2>
            <div className="landing-container-grid">
              {cardData.map((card, index) => (
                <div className="landing-container-card" key={index}>
                  <div className="landing-container-icon">
                    <img src={card.image} alt={card.title} />
                  </div>
                  <h3 className="landing-container-card-title">{card.title}</h3>
                  <p className="landing-container-card-desc">
                    {card.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div>
        <h1 className="share_page_feature_new">What Our Customers Say</h1>

        <div className="slider_last_01 last_slider_new_one">
          {/* <Slider {...settings}>
      {testimonials.map((item, i) => (
        <div key={i} className="testimonial-slide">
          <div className="testimonial-card">
            <img src={icon11} alt="icon" className="testimonial-image" />
 
            <p className="testimonial-user">{item.user}</p>
            <p className="testimonial-text">{item.text}</p>
          </div>
        </div>
      ))}
    </Slider> */}
          <Slider {...settings}>
            {testimonials.map((item, i) => (
              <div key={i} className="testimonial-slide">
                <div className="testimonial-card">
                  {/* Top-left quote image */}
                  <img
                    src={topQuoteImage}
                    className="quote-icon top"
                    alt="quote"
                  />

                  <p className="testimonial-text">{item.text}</p>

                  {/* Bottom-right quote image */}
                  <img
                    src={bottomQuoteImage}
                    className="quote-icon bottom"
                    alt="quote"
                  />

                  <p className="testimonial-user">{item.user}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="new_landing_footer">
        <Footers_index />
      </div>
    </div>
  );
};
function Callout({ text, desc, side }) {
  return (
    <div className={`${styles.callout} ${side}`}>
      <h4>{text}</h4>
      <p>{desc}</p>
      <span className={styles.line} />
    </div>
  );
}
// Map Redux state to component props
const mapStateToProps = (state) => ({
  isTamil: state.LanguageReducer.isTamil,
});

export default connect(mapStateToProps)(SharethisApp);
